import { render, staticRenderFns } from "./MPNResearchBatchV2.vue?vue&type=template&id=e3fdcbc4&scoped=true"
import script from "./MPNResearchBatchV2.vue?vue&type=script&lang=js"
export * from "./MPNResearchBatchV2.vue?vue&type=script&lang=js"
import style0 from "./MPNResearchBatchV2.vue?vue&type=style&index=0&id=e3fdcbc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fdcbc4",
  null
  
)

export default component.exports